// extracted by mini-css-extract-plugin
export default {"main":"_1fefd1bafa","tit":"_4b00903126","maintitle":"ee32cfb3bc","ylw":"_685585521d","white":"_7c2d7e20e8","mv_title":"c418d83b8c","mv_nc":"_464ccb6593","mv_in":"fef9dcbd24"};